import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import SimpleReactLightbox from 'simple-react-lightbox';

import Waste360 from './components/Waste360';

ReactDOM.render(
  <SimpleReactLightbox>
      <Waste360 />
  </SimpleReactLightbox>,
  document.getElementById('Waste360Main')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();